import { boot } from 'quasar/wrappers'
import { NavigationGuardNext, Route } from 'vue-router'
import { DefaultRole } from 'able-lib'

export default boot(({ store, router, urlPath, redirect }) => {
  store.dispatch('local/checkMaintenance')

  router.beforeEach((to: Route, from: Route, next: NavigationGuardNext) => {
    const maintenanceInfo = store.state.local.maintenanceInfo
    const isInLoginPage = urlPath.includes('/#/login')

    if (!isInLoginPage && maintenanceInfo.effetive_state) {
      const isDeveloper = store.getters['user/hasRole'](DefaultRole.DEVELOPER)

      if (!isDeveloper) {
        redirect('/login')
        return
      }
    }

    next()
  })
})
